import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { IoMusicalNotes, IoSearchOutline } from 'react-icons/io5';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import Spinner from 'react-bootstrap/Spinner';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const Artist = () => {
  const [searchParams] = useSearchParams();
  const [songs, setSongs] = useState([]);
  const [artist, setArtist] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [songCost, setSongCost] = useState(null);
  const [songToAdd, setSongToAdd] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showInsufficient, setShowInsufficient] = useState(false);
  useEffect(() => {
    if (isError) {
      const timeout = setTimeout(() => {
        cancelMsg(); // Set isError to false
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [isError]);

  const navigate = useNavigate();

  function goBack() {
    window.history.back();
  }

  useEffect(() => {
    const fetchSongs = async () => {
      const aid = searchParams.get('aid');
      if (!aid) {
        setErrorMsg('No artist Id found');
        setIsError(true);
        return;
      }
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }
      // console.log(aid);

      try {
        const songsResponse = await fetchWithAuth(
          API_ENDPOINTS.TRACK_BY_ARTIST(aid),
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        if (!songsResponse.ok) {
          const errorData = await songsResponse.json();
          const errormsg =
            errorData?.message || errorData?.error || 'Something went wrong';
          setErrorMsg(errormsg.toString());
          setIsError(true);
          // alert(`HTTP ${response.status}: ${errorMsg}`);
        }

        if (songsResponse.status === 204) {
          return;
        }

        const songsdata = await songsResponse.json();
        setSongs(songsdata);

        setArtist(songsdata[0].artists);
      } catch (e) {
        console.log('Error :', e);
      }
    };
    fetchSongs();
  }, []);

  // ...existing code...
  const openConfirm = song => {
    const venueId = localStorage.getItem('vId');
    if (!venueId) {
      setConfirmModal(false);
      setIsError(true);
      setErrorMsg('Please select a Venue');
      return;
    }
    const cost = localStorage.getItem('songCost');
    if (!cost) {
      // console.error("No cost found");
      return;
    }
    setSongCost(cost);
    setSongToAdd(song);

    // Check coins
    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    if (profile.coins < cost) {
      setShowInsufficient(true);
      setConfirmModal(false);
    } else {
      setConfirmModal(true);
      setShowInsufficient(false);
    }
  };

  const cancelConfirm = song => {
    setSongToAdd([]);
    setConfirmModal(false);
  };

  const onAddSong = async trackId => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      const venueId = localStorage.getItem('venueId');
      if (!venueId) {
        console.error('No venue token found');
        setErrorMsg('No Venue Found');
        setIsLoading(false);
        setIsError(true);
        setConfirmModal(false);
        return;
      }
      if (localStorage.getItem('shoutout') === 'true') {
        localStorage.setItem('shouttrackId', trackId);
        navigate('/shoutout');

        return;
      }

      const addResponse = await fetchWithAuth(
        API_ENDPOINTS.VENUE_QUEUE(venueId),
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            trackId: trackId,
          }),
        }
      );

      if (!addResponse.ok) {
        const errorData = await addResponse.json(); // try to parse the error message
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setErrorMsg(errormsg.toString());
        setIsLoading(false);
        setIsError(true);
        setConfirmModal(false);
        return;
        // alert(`HTTP ${response.status}: ${errorMsg}`);
      }

      if (addResponse.status === 204) {
        // console.log("Request was successful, but no content returned.");
        localStorage.setItem('notif', true);
        setIsLoading(false);
        setConfirmModal(false);
        setSongToAdd([]);
        // alert("Successfully requested Song");
        navigate(`/venues/${venueId}`);
        return;
      }
    } catch (error) {
      // console.error("Error requesting songs:", error);
      // alert("Select a Venue");
      setConfirmModal(false);
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   const token = localStorage.getItem('tringAuthToken');
  //   if (!token) {
  //     console.error('No auth token found');
  //     navigate('/');
  //     return;
  //   }
  // });

  const cancelMsg = () => {
    setIsError(false);
  };

  return (
    <div
      className="w-100 px-2 d-flex flex-column position-relative"
      style={{ height: '100dvh' }}
    >
      {confirmModal ? (
        <div className="modale position-relative">
          <div className="overlay" onClick={() => cancelConfirm()}></div>

          <div className="modale-content">
            <div
              className="w-100 p-3 d-flex flex-row"
              style={{
                borderRadius: '15px 15px 0px 0px',
                background: 'linear-gradient(90deg, #C91721 0%, #8A325D 100%)',
              }}
            >
              <div className="col-3"></div>
              <div className=" col-9 d-flex flex-row justify-content-between">
                <h4 className="m-0" style={{ color: 'white' }}>
                  Song Request
                </h4>

                <button
                  className=""
                  style={{
                    color: 'white',
                    background: 'transparent',
                    border: 'none',
                  }}
                  onClick={() => cancelConfirm()}
                >
                  <IoMdCloseCircleOutline
                    style={{ color: 'white', fontSize: '25px' }}
                  />{' '}
                </button>
              </div>
            </div>

            {songToAdd ? (
              <div className="w-100">
                <div className="px-3 py-4 w-100" style={{ background: '#FFF' }}>
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <div
                      className="d-flex flex-row align-items-center"
                      style={{ gap: '15px' }}
                    >
                      <img
                        src={songToAdd.album.images[0].url}
                        style={{
                          height: '60px',
                          width: '60px',
                          borderRadius: '50%',
                        }}
                      />
                      <span
                        style={{
                          color: '#9F2A4A',
                          fontSize: 'clamp(0px,4vw,16px)',
                        }}
                        className="text-start col-8"
                      >
                        {songToAdd.name}
                      </span>
                    </div>

                    {localStorage.getItem('shoutout') !== 'true' && (
                      <div>
                        <img
                          src="/images/coin.svg"
                          style={{
                            width: 'clamp(0px,5vw,20px)',
                            aspectRatio: '1/1',
                          }}
                        />
                        <h4
                          style={{
                            color: '#9F2A4A',
                            fontSize: 'clamp(0px,4vw,16px)',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {songCost} coin
                        </h4>
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                  <button
                    className="col-6 p-2"
                    style={{
                      background: '#FFF',
                      color: '#C71823',
                      border: 'solid .5px #C71823',
                      borderRadius: '0px 0px 0px 15px',
                      fontSize: '18px',
                    }}
                    onClick={() => cancelConfirm()}
                  >
                    Cancel
                  </button>

                  <button
                    className="col-6 p-2"
                    style={{
                      background:
                        'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                      color: 'white',
                      border: 'solid .5px #C71823',
                      borderRadius: '0px 0px 15px 0px',
                      fontSize: '18px',
                    }}
                    onClick={() => onAddSong(songToAdd.id)}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            ) : (
              <div>Just a sec</div>
            )}
          </div>
        </div>
      ) : (
        <div></div>
      )}

      {showInsufficient && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100dvh',
            background: 'rgba(0, 0, 0, 0.15)',
            backdropFilter: 'blur(2px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setShowInsufficient(false)}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '16px',
              width: '90%',
              maxWidth: 400,
              boxShadow: '0 4px 32px rgba(0,0,0,0.2)',
              overflow: 'hidden',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div
              style={{
                background: 'linear-gradient(90deg, #C91721 0%, #8A325D 100%)',
                padding: '16px',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '16px 16px 0 0',
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <IoMusicalNotes
                  style={{
                    fontSize: 24,
                    marginRight: 10,
                    color: '#fff',
                  }}
                />
                <span
                  style={{
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '18px',
                  }}
                >
                  Not Enough Coins!
                </span>
              </div>
            </div>

            <div
              style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: '#fff',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <img
                  src={songToAdd?.album?.images[0]?.url}
                  alt="Album"
                  style={{
                    height: 60,
                    width: 60,
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
                <span
                  style={{
                    color: '#9F2A4A',
                    fontSize: '16px',
                    fontWeight: 500,
                    maxWidth: 180,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {songToAdd?.name}
                  <br />
                  {songToAdd?.artist}
                </span>
              </div>
              <div style={{ textAlign: 'center' }}>
                <img
                  src="/images/coin.svg"
                  alt="coin"
                  style={{
                    width: 30,
                    height: 30,
                    marginBottom: 4,
                  }}
                />
                <div
                  style={{
                    color: '#9F2A4A',
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  {songCost} coins
                </div>
              </div>
            </div>

            <div style={{ borderTop: '1px solid #ddd', display: 'flex' }}>
              <button
                style={{
                  flex: 1,
                  padding: '12px 0',
                  background: '#fff',
                  border: 'none',
                  fontSize: 16,
                  color: '#C91721',
                  fontWeight: 500,
                  borderBottomLeftRadius: 16,
                  cursor: 'pointer',
                }}
                onClick={() => setShowInsufficient(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1,
                  padding: '12px 0',
                  background:
                    'linear-gradient(90deg,#CC151E -18.35%,#873662 108.23%)',
                  border: 'none',
                  fontSize: 16,
                  color: '#fff',
                  fontWeight: 500,
                  borderBottomRightRadius: 16,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setShowInsufficient(false);
                  navigate(
                    `/buy?songRequested=${
                      songToAdd?.id || ''
                    }&venueId=${localStorage.getItem('vId')}`
                  );
                }}
              >
                Get Coins
              </button>
            </div>
          </div>
        </div>
      )}

      {isError && (
        <div
          style={{
            position: 'fixed',
            bottom: '80px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            color: 'white',
            background: 'rgba(236, 236, 236, 1)',
            borderRadius: '20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.32)',
            padding: '16px 24px',
            minWidth: '300px',
            maxWidth: '90vw',
            animation: 'slideDown 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <img
            src="/images/logo.svg"
            style={{
              width: '18px',
              height: '18px',
              flexShrink: 0,
            }}
          />
          <div
            style={{
              color: 'black',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            {typeof errorMsg === 'string'
              ? errorMsg
              : errorMsg?.message || 'Something went wrong'}
          </div>
        </div>
      )}

      {isLoading ? (
        <div className="lmodale">
          <div className="loverlay"></div>

          <div className="lmodalecontent">
            <Spinner animation="border" role="status" style={{ color: 'red' }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div
        className="d-flex flex-row align-items-center w-100 my-3"
        style={{
          color: '#D0151C',
          background: 'linear-gradient(90deg, #641FAA 0%, #8A325D 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        <IoIosArrowBack
          className="mt-1"
          style={{
            fontSize: '22px',
            marginRight: '10px',
            color: '#8A325D',
          }}
          onClick={() => goBack()}
        />
        <h2 className="m-0">
          {artist.length !== 0 ? artist[0]?.name : 'Artist...'}
        </h2>
      </div>

      {artist?.length === 0 || songs?.length === 0 ? (
        <div
          className="w-100 d-flex flex-column align-items-center"
          style={{ flexGrow: 1 }}
        >
          <div
            className="shimmer"
            style={{ height: '30dvh', width: '70%', borderRadius: '5px' }}
          ></div>
          <div
            className="w-100 d-flex flex-column justify-content-between align-items-center mt-3 mb-2"
            style={{ flexGrow: 1 }}
          >
            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ gap: '10px', width: '95%' }}
            >
              <div
                className="shimmer my-2"
                style={{ height: '5dvh', borderRadius: '8px', flexGrow: 1 }}
              ></div>
            </div>

            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ gap: '10px', width: '95%' }}
            >
              {/* <div className="shimmer" style={{borderRadius:"50%",width:"6dvh",height:"6dvh"}}></div> */}
              <div
                className="shimmer my-2"
                style={{ height: '5dvh', borderRadius: '8px', flexGrow: 1 }}
              ></div>
            </div>

            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ gap: '10px', width: '95%' }}
            >
              {/* <div className="shimmer" style={{borderRadius:"50%",width:"6dvh",height:"6dvh"}}></div> */}
              <div
                className="shimmer my-2"
                style={{ height: '5dvh', borderRadius: '8px', flexGrow: 1 }}
              ></div>
            </div>

            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ gap: '10px', width: '95%' }}
            >
              {/* <div className="shimmer" style={{borderRadius:"50%",width:"6dvh",height:"6dvh"}}></div> */}
              <div
                className="shimmer my-2"
                style={{ height: '5dvh', borderRadius: '8px', flexGrow: 1 }}
              ></div>
            </div>

            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ gap: '10px', width: '95%' }}
            >
              {/* <div className="shimmer" style={{borderRadius:"50%",width:"6dvh",height:"6dvh"}}></div> */}
              <div
                className="shimmer my-2"
                style={{ height: '5dvh', borderRadius: '8px', flexGrow: 1 }}
              ></div>
            </div>

            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ gap: '10px', width: '95%' }}
            >
              {/* <div className="shimmer" style={{borderRadius:"50%",width:"6dvh",height:"6dvh"}}></div> */}
              <div
                className="shimmer my-2"
                style={{ height: '5dvh', borderRadius: '8px', flexGrow: 1 }}
              ></div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex flex-column"
          style={{ flexGrow: 1, overflow: 'scroll', scrollBehavior: 'smooth' }}
        >
          <div className="w-100">
            <img
              className="col-6 my-1"
              src={artist.length !== 0 ? artist[0]?.images[0]?.url : ''}
              style={{ borderRadius: '13px', aspectRatio: '1/1' }}
            />
          </div>

          <div
            className="d-flex flex-row align-items-center py-2 px-3 my-3 "
            style={{
              gap: '15px',
              borderRadius: '10px',
              border: '1px solid #C3C0C0',
              fontSize: '20px',
            }}
            onClick={() => {
              navigate('/searchSong');
            }}
          >
            <IoSearchOutline className="mt-1" />
            <input
              type="text"
              style={{
                border: 'none',
                background: 'transparent',
                outline: 'none',
              }}
              //   onChange={onChangeSearch}
              placeholder="Search for a song..."
              className=" text-start"
            />
          </div>

          <div
            style={{
              flexGrow: 1,
              overflow: 'scroll',
              scrollBehavior: 'smooth',
            }}
          >
            {songs.map((song, index) => (
              <div key={index}>
                <div className="mb-3">
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <img
                      className="mx-2"
                      style={{
                        height: '55px',
                        width: '55px',
                        borderRadius: '50%',
                      }}
                      src={song?.album?.images[0]?.url}
                    />

                    <div
                      className="d-flex flex-column mx-2 text-start overflow-hidden"
                      style={{ gap: '5px', width: '50%' }}
                    >
                      <h5
                        className="text-start col-6 mb-0"
                        style={{
                          fontSize: 'clamp(0px,4vw,18px)',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {song?.name}
                      </h5>
                      <div
                        className="w-100 overflow-hidden d-flex flex-row justify-content-start align-items-center"
                        style={{ gap: '5px' }}
                      >
                        {song?.artists.slice(0, 2).map((artist, index) => (
                          <span
                            key={index}
                            className="text-start overflow-hidden common-txt"
                            style={{
                              fontSize: 'clamp(0px,3.3vw,15px)',
                              whiteSpace: 'nowrap',
                              color: 'gray',
                              maxWidth: '40%',
                            }}
                          >
                            {artist?.name}
                          </span>
                        ))}
                        {song?.artists?.length > 2 && (
                          <div
                            className=""
                            style={{
                              aspectRatio: '1/1',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: 'clamp(0px,3.3vw,15px)',
                              color: 'gray',
                            }}
                          >
                            +{song?.artists?.length - 2}
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      className="mx-2 px-3 py-2 my-2"
                      style={{
                        color: 'white',
                        border: 'none',
                        background:
                          'linear-gradient(90deg, #D51217 0%, #843866 100%)',
                        height: 'fit-content',
                        fontSize: 'clamp(0px,3.3vw,15px)',
                        whiteSpace: 'nowrap',
                        borderRadius: '15px',
                      }}
                      onClick={() => openConfirm(song)}
                    >
                      + Add
                    </button>
                  </div>
                  <hr />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Artist;
